import Notification20 from '@carbon/icons-react/es/notification/20';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { NotificationsConfiguration } from 'components/organisms/notifications';
// import { KBLinks } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
// import { FormattedMessage } from 'react-intl';

const NotificationsConfigPage = styled(NotificationsConfiguration)`
  margin: var(--layout-03) 0 0 var(--spacing-03);
  padding: var(--layout-03);
`;
const Header = styled.span`
  align-items: center;
  display: flex;
  flex: 1;
`;

// const CTALink = styled.a`
//   align-items: center;
//   display: flex;

//   > svg {
//     margin-right: var(--spacing-03);
//   }
// `;

export const NotificationSettingsPage: FC = () => {
  const {
    user: { userType },
  } = useUser();
  const title = useTranslation(
    userType === 'EXTERNAL' ? 'notification_settings' : 'notifications',
  );

  return (
    <Page>
      <Page.Header
        $white
        sticky
        title={
          <Header>
            <HeaderWithIconTitle icon={<Notification20 />} title={title} />
            {/* <CTALink
              href={KBLinks.manageNotification}
              target="_blank"
              rel="noreferrer"
            >
              <Launch16 />
              <FormattedMessage id="settings.notifications.header.cta" />
            </CTALink> */}
          </Header>
        }
      />
      <Page.Content>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <NotificationsConfigPage />
      </Page.Content>
    </Page>
  );
};
